import React from "react";
import { HeaderCMS, HeaderGuest } from "components/Header";
import Footer from "components/Footer/Footer";
import styles from "./LayoutLoginAndRegister.module.scss";
import { Layout } from "antd";
import useAuth from "context/auth";
import useWindowSize from "hook/useWindowSize";
import useComponentDimension from "util/useComponentDimension";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const { Content } = Layout;

const LayoutLoginAndRegister = (props) => {
  const {
    state: { user, isAuthenticated },
  } = useAuth();
  const { width, height } = useWindowSize();
  const [ref, dimensions] = useComponentDimension();
  const history = useHistory();

  return (
    <div
      className={styles.content}
      style={
        history.location.pathname === "/login"
          ? { height: `100vh` }
          : // ? { height: `${height - dimensions.height}px` }
            { height: `120vh` }
      }
    >
      <div className={styles.divLayout}>
        {isAuthenticated ? (
          <HeaderCMS {...props.children.props} user={user} />
        ) : (
          <HeaderGuest />
        )}
        <Content
          className="site-layout"
          style={
            width > 1000
              ? { marginTop: "8%", backgroundColor: "transparent" }
              : { marginTop: "17%", backgroundColor: "transparent" }
          }
        >
          <div
            className="site-layout-background"
            style={width < 800 ? { margin: "1rem" } : {}}
          >
            {props.children}
          </div>
        </Content>
      </div>
      <div ref={ref}>
        <Footer props={props.children.props} className={styles.footer} />
      </div>
    </div>
  );
};
export default LayoutLoginAndRegister;
